import isArray from 'lodash/isArray';
import last from 'lodash/last';

import { findTagByType } from '@eb/redux-destination';

import {
    getSearchEventHeaderTitle,
    formatDateRangeStringForDisplay,
} from '../../utils/general';

import { FORMAT_TAG_TYPE, CATEGORY_TAG_TYPE } from '../../constants';

/**
 * Counts the currently selected filters
 * @param  {Object} state Current application state
 * @return {Nubmer}       Number of selected filters
 */
export const getSelectedFilterCount = (state) => {
    const {
        search: { eventSearch },
    } = state;

    return (
        // Dates will be a string if no date is selected, else array
        // Dates always has at least "current_future" already, so don't count it
        (Array.isArray(eventSearch.dates) ? eventSearch.dates.length - 1 : 0) +
        // A custom date would show up in a different way
        (eventSearch.dateRange.to && eventSearch.dateRange.from ? 1 : 0) +
        // Categories and formats are both tags, and you can only select one of each right now
        eventSearch.tags.length +
        // Price is either empty string, paid or free
        (eventSearch.price !== '' ? 1 : 0) +
        // Language and currency are both only able to select one
        eventSearch.currencies.length +
        (eventSearch.languages.length >= 1 ? 1 : 0)
    );
};

//If no date filter is applied the value will
//default to "current_future", if any filters
//are applied we will receive an array with
//both 'current_future' and whatever other
//filters. But that is only instance of more
//than one filter so we can feel safe returning
//the second option.
export const getSelectedDate = (
    date,
    { from: startDate, to: endDate } = {},
) => {
    let dateToReturn;

    if (isArray(date)) {
        dateToReturn = last(date);
    }

    if (startDate && endDate) {
        dateToReturn = formatDateRangeStringForDisplay({ startDate, endDate });
    }

    return dateToReturn;
};

export const getSelectedCategory = (tags) =>
    findTagByType(CATEGORY_TAG_TYPE, tags);
export const getSelectedFormat = (tags) => findTagByType(FORMAT_TAG_TYPE, tags);

export const getSearchHeaderTitle = (state) => {
    if (state.botH1) {
        return state.botH1;
    }

    return getSearchEventHeaderTitle(
        {
            currentPlace: state.location.currentPlace,
            currentPlaceParent: state.location.currentPlaceParent,
            placeType: state.location.placeType,
        },
        {
            eventSearch: state.search.eventSearch,
        },
    );
};
